import * as React from 'react';



export default class Emptylog extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="252" height="171" viewBox="0 0 252 171" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
        <defs>
        <linearGradient id="logs__a" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#E8ECEE"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="logs__c" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E8ECEE"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="logs__d" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E8ECEE"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="logs__f" x1="50%" x2="50%" y1="3.87%" y2="115.769%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="logs__k" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E6E8E9"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="logs__m" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#F3F3F3"/>
            <stop offset="100%" stopColor="#E6ECEF"/>
        </linearGradient>
        <linearGradient id="logs__p" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E6E8E9"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="logs__r" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stopColor="#E6E8E9"/>
            <stop offset="100%" stopColor="#EFF1F3"/>
        </linearGradient>
        <linearGradient id="logs__u" x1="100%" x2="0%" y1="50%" y2="50%">
            <stop offset="0%" stopColor="#42ABEF" stopOpacity=".413"/>
            <stop offset="100%" stopColor="#EDF0F1"/>
        </linearGradient>
        <linearGradient id="logs__x" x1="56.545%" x2="-.964%" y1="117.006%" y2="63.913%">
            <stop offset="0%" stopColor="#E2E5E7"/>
            <stop offset="100%" stopColor="#F6F9FA"/>
        </linearGradient>
        <linearGradient id="logs__A" x1="68.672%" x2="-95.394%" y1="117.006%" y2="63.913%">
            <stop offset="0%" stopColor="#E2E5E7"/>
            <stop offset="100%" stopColor="#F6F9FA"/>
        </linearGradient>
        <path id="logs__b" d="M0.968 10.308L0.399 22.271 34.998 8.285 26.235 0.094z"/>
        <path id="logs__e" d="M251.297 98.872C237.765 42.284 186.58.195 125.507.195 65.21.195 14.554 41.22.253 96.72"/>
        <path id="logs__h" d="M0.698 9.412L0.179 20.335 31.813 7.564 23.8 0.086z"/>
        <path id="logs__i" d="M0.701 5.274L21.324 13.675 20.984 6.489 5.925 0.355z"/>
        <path id="logs__l" d="M11.257 3.7S4.922 4.706 2.744 13.799c-2.177 9.092-8.372 34.977 13.2 31.427 0 0 10.523 6.555 8.576 20.07-.973 6.759 1.136 8.937 3.487 9.424 2.773.574 5.481-1.228 6.31-3.956 1.057-3.485 2.012-9.83-.154-19.28 0 0 10.186 22.523 14.669 18.155 4.482-4.369 4.396-2.49-1.933-20.883-6.33-18.395-13.33-14.267-13.33-14.267s8.725-20.884 1.098-31.523C33.388 1.182 30.684.564 27.551.564 20.49.564 11.257 3.7 11.257 3.7"/>
        <path id="logs__o" d="M11.257 3.7S4.922 4.706 2.744 13.799c-2.177 9.092-8.372 34.977 13.2 31.427 0 0 10.523 6.555 8.576 20.07-.973 6.759 1.136 8.937 3.487 9.424 2.773.574 5.481-1.228 6.31-3.956 1.057-3.485 2.012-9.83-.154-19.28 0 0 10.186 22.523 14.669 18.155 4.482-4.369 4.396-2.49-1.933-20.883-6.33-18.395-13.33-14.267-13.33-14.267s8.725-20.884 1.098-31.523C33.388 1.182 30.684.564 27.551.564 20.49.564 11.257 3.7 11.257 3.7"/>
        <path id="logs__q" d="M1.502 14.962C-2.887 26.557 2.9 39.534 14.423 43.95c11.525 4.414 24.426-1.406 28.814-13 4.389-11.593-1.396-24.571-12.92-28.986C27.7.962 25.016.488 22.374.488 13.375.488 4.894 6 1.502 14.962"/>
        <path id="logs__t" d="M2.15 14.78c-3.613 9.438-.305 19.806 7.434 25.577 9.639.808 19.045-4.746 22.659-14.182 3.614-9.438.305-19.806-7.433-25.577C24.19.546 23.57.52 22.954.52 13.986.52 5.532 5.951 2.15 14.78"/>
        <path id="logs__w" d="M8.487 1.372c.165.346.595.84.698 1.26.98 3.958 2.548 8.457.963 11.88-1.163 2.512-3.854 5.549-6.453 7.287-5.423 3.622-3.91 9.074.645 6.51C30.074 16.655 7.695.053 7.695.053c.45.457.49.688.792 1.319"/>
        <path id="logs__z" d="M.498 13.767c.65 4.137 15.99 8.592 18.818 8.823 2.127.174 2.912-1.56 1.778-3.392-.657-1.061-1.801-1.713-3.038-1.976C8.601 15.209 4.002.672 4.002.672L.498 13.766z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g>
            <g transform="translate(0 67) translate(66)">
                <path fill="url(#logs__a)" d="M0.968 10.308L0.399 22.271 34.998 8.285 26.235 0.094z"/>
                <use fill="url(#logs__c)" xlinkHref="#logs__b"/>
            </g>
            <path fill="url(#logs__d)" d="M164.169 11.651L186.471 20.651 186.105 12.954 169.818 6.38z" transform="translate(0 67)"/>
            <g transform="translate(0 67) translate(0 5)">
                <mask id="logs__g" fill="#fff">
                    <use xlinkHref="#logs__e"/>
                </mask>
                <path fill="url(#logs__f)" d="M251.294 98.863c-1.852-7.742-4.408-15.213-7.599-22.341C223.568 31.55 178.222.195 125.507.195c-51.86 0-96.589 30.348-117.19 74.152C4.856 81.709 2.076 89.45.058 97.493" mask="url(#logs__g)"/>
                <g>
                    <path fill="#EBEDEF" d="M88.163 5.594c0 2.726-7.536 4.936-16.834 4.936-9.297 0-16.833-2.21-16.833-4.936S62.032.658 71.33.658c9.298 0 16.834 2.21 16.834 4.936" transform="translate(55 11)"/>
                    <path fill="#F0F2F4" d="M33.792 30.983c0 4.274-7.536 7.74-16.834 7.74-9.296 0-16.833-3.466-16.833-7.74s7.537-7.74 16.833-7.74c9.298 0 16.834 3.466 16.834 7.74" transform="translate(55 11)"/>
                    <path fill="#F0F4F6" d="M71.33 48.562c0 1.59-2.803 2.878-6.26 2.878s-6.26-1.288-6.26-2.878 2.803-2.878 6.26-2.878 6.26 1.289 6.26 2.878" transform="translate(55 11)"/>
                    <path fill="#F4F5F6" d="M88.163 75.774c0 1.59-2.802 2.878-6.259 2.878-3.457 0-6.26-1.288-6.26-2.878s2.803-2.878 6.26-2.878 6.259 1.289 6.259 2.878M144.965 66.36c0 4.076-7.187 7.38-16.053 7.38-8.867 0-16.054-3.304-16.054-7.38 0-4.075 7.187-7.38 16.054-7.38 8.866 0 16.053 3.305 16.053 7.38M33.792 70.848c0 2.72-4.798 4.926-10.716 4.926-5.92 0-10.717-2.206-10.717-4.926 0-2.721 4.798-4.928 10.717-4.928 5.918 0 10.716 2.207 10.716 4.928" transform="translate(55 11)"/>
                </g>
            </g>
        </g>
        <g>
            <g transform="translate(76) translate(0 73)"/>
            <g transform="translate(76) translate(89 79)">
                <mask id="logs__j" fill="#fff">
                    <use xlinkHref="#logs__i"/>
                </mask>
                <path d="M0.701 5.274L21.324 13.675 20.984 6.489 5.925 0.355z" mask="url(#logs__j)"/>
            </g>
            <path fill="url(#logs__k)" d="M13.14.635S2.77-2.297 2.968 6.77c.197 9.069-5.719 39.828-.003 39.921 5.716.094 11.626 1.003 11.823-4.97.196-5.974 3.436-33.455 3.436-33.455V1.843L13.14.635z" transform="translate(76) translate(45 31)"/>
            <g transform="translate(76) translate(57 39)">
                <mask id="logs__n" fill="#fff">
                    <use xlinkHref="#logs__l"/>
                </mask>
                <path fill="url(#logs__m)" d="M24.55 66.362c-.548 5.901 1.509 7.881 3.784 8.35 2.88.591 5.692-1.265 6.552-4.076.346-1.13.681-2.552.908-4.274H24.551z" mask="url(#logs__n)"/>
                <g>
                    <use fill="url(#logs__p)" xlinkHref="#logs__o"/>
                </g>
            </g>
            <g transform="translate(76) translate(57)">
                <mask id="logs__s" fill="#fff">
                    <use xlinkHref="#logs__q"/>
                </mask>
                <path fill="url(#logs__r)" d="M1.502 14.962C-2.887 26.557 2.9 39.534 14.423 43.95c11.525 4.414 24.426-1.406 28.814-13 4.389-11.593-1.396-24.571-12.92-28.986C27.7.962 25.016.488 22.374.488 13.375.488 4.894 6 1.502 14.962" mask="url(#logs__s)"/>
            </g>
            <g transform="translate(76) translate(68 5)">
                <mask id="logs__v" fill="#fff">
                    <use xlinkHref="#logs__t"/>
                </mask>
                <path fill="url(#logs__u)" d="M2.15 14.78c-3.613 9.438-.305 19.806 7.434 25.577 9.639.808 19.045-4.746 22.659-14.182 3.614-9.438.305-19.806-7.433-25.577C24.19.546 23.57.52 22.954.52 13.986.52 5.532 5.951 2.15 14.78" mask="url(#logs__v)"/>
            </g>
            <g transform="translate(76) translate(84 42)">
                <mask id="logs__y" fill="#fff">
                    <use xlinkHref="#logs__w"/>
                </mask>
                <path fill="url(#logs__x)" d="M8.487 1.372c.165.346.595.84.698 1.26.98 3.958 2.548 8.457.963 11.88-1.163 2.512-3.854 5.549-6.453 7.287-5.423 3.622-3.91 9.074.645 6.51C30.074 16.655 7.695.053 7.695.053c.45.457.49.688.792 1.319" mask="url(#logs__y)"/>
            </g>
            <g transform="translate(76) translate(63 50)">
                <mask id="logs__B" fill="#fff">
                    <use xlinkHref="#logs__z"/>
                </mask>
                <path fill="url(#logs__A)" d="M.498 13.767c.65 4.137 15.99 8.592 18.818 8.823 2.127.174 2.912-1.56 1.778-3.392-.657-1.061-1.801-1.713-3.038-1.976C8.601 15.209 4.002.672 4.002.672L.498 13.766z" mask="url(#logs__B)"/>
            </g>
        </g>
    </g>
        </svg>
    )
  }
}
